var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderOpen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.5H6C3.71 2.5 2.5 3.71 2.5 6V18C2.5 20.29 3.71 21.5 6 21.5H18C20.29 21.5 21.5 20.29 21.5 18V6C21.5 3.71 20.29 2.5 18 2.5ZM6 3.5H18C19.729 3.5 20.5 4.271 20.5 6V11.5H3.5V6C3.5 4.271 4.271 3.5 6 3.5ZM18 20.5H6C4.271 20.5 3.5 19.729 3.5 18V12.5H20.5V18C20.5 19.729 19.729 20.5 18 20.5ZM11.25 8.00195C11.25 7.58795 11.586 7.25195 12 7.25195C12.414 7.25195 12.75 7.58795 12.75 8.00195C12.75 8.41595 12.414 8.75195 12 8.75195C11.586 8.75195 11.25 8.41695 11.25 8.00195ZM12.75 16C12.75 16.414 12.414 16.75 12 16.75C11.586 16.75 11.25 16.414 11.25 16C11.25 15.586 11.586 15.25 12 15.25C12.414 15.25 12.75 15.586 12.75 16Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderOpen);
export default ForwardRef;